import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldWrapper, FlexBox } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';
import { analytics } from 'app/utils/segment';
import { isNullishFilterOperator } from '../../../../utils/filters/isNullishFilterOperator';
import { useSearchFilters } from '../../searchFilters.context';
import { filterFieldAssets, filterValidationErrors, } from '../../utils/definitions';
import { ConditionActions } from './components/actions/conditionActions';
import { ConditionField } from './components/field/conditionField';
import { ConditionOperator } from './components/operator/conditionOperator';
import styles from './filterCondition.module.scss';
/**
 * Represents a component that can be used to apply some conditions to a search
 * filter
 */
export const FilterCondition = (props) => {
    const { index, condition } = props;
    const [error, setError] = useState(null);
    const { validation: { errors }, updateCondition, } = useSearchFilters();
    /** If an error is set from the context, we update the internal state. */
    useEffect(() => {
        if (errors[index]) {
            setError(filterValidationErrors[errors[index]]);
        }
        else {
            setError(null);
        }
    }, [errors, index]);
    /** Updates the condition in the context state with the specified operator. */
    const handleChangeOperator = (operator) => {
        const newCondition = Object.assign(Object.assign({}, condition), { operator, values: isNullishFilterOperator(operator) ? [] : condition.values });
        updateCondition(index, newCondition);
        analytics.searchFilterOperatorUpdated({ type: condition.field, operator });
    };
    /** Updates the condition in the context state with the specified values. */
    const handleChangeValues = (values) => {
        const newCondition = Object.assign(Object.assign({}, condition), { values });
        updateCondition(index, newCondition);
    };
    /**
     * The input label including the name of the field and the dropdown to select
     * the operator.
     */
    const label = (_jsxs(FlexBox, Object.assign({ alignItems: "center" }, { children: [_jsx("span", { children: filterFieldAssets[condition.field].label }), _jsx(ConditionOperator, { condition: condition, onChange: handleChangeOperator })] })));
    return (_jsx(FieldWrapper, Object.assign({ className: styles.root, label: label, labelFor: `${condition.field}-${index}`, meta: { error }, noAlert: !error }, { children: _jsxs("div", Object.assign({ className: styles.wrapper }, { children: [_jsx(ConditionField, { condition: condition, placeholder: "Choose one or more values", disabled: isNullishFilterOperator(condition.operator), onChange: handleChangeValues, onError: setError }), _jsx(ConditionActions, { index: index, condition: condition })] })) })));
};
